module.exports = __webpack_public_path__ + "0bec3b5fed8171a4bc71151cab48565e.pdf";